/* PREȚURI DE TOP – Polyglot-Pro pagină de produs premium
   JavaScript simplu, fără dependențe.
   Cronometrele și stocul folosesc date REALE: data de final a ofertei setată în editor,
   stocul din Shopify și ora limită de procesare a comenzilor. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('pdt-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var form = $('[data-pdt-form]');
  var state = { variant: null };

  /* ---------- variante ---------- */
  function findVariant(id) {
    for (var i = 0; i < cfg.variants.length; i++) if (String(cfg.variants[i].id) === String(id)) return cfg.variants[i];
    return null;
  }
  function selectedOptions() {
    return $$('[data-pdt-option]').map(function (fs) {
      var c = $('input:checked', fs);
      return c ? c.value : null;
    });
  }
  function matchVariant(vals) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) if (v.options[j] !== vals[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  function setVariant(v, updateUrl) {
    state.variant = v;
    var idInput = form ? $('[data-pdt-variant-id]', form) : null;
    if (idInput) { idInput.value = v ? v.id : ''; idInput.disabled = !v; }
    $$('[data-pdt-price]').forEach(function (el) { el.textContent = v ? v.priceFmt : ''; });
    var hasDiscount = !!(v && v.compare > v.price);
    $$('[data-pdt-compare]').forEach(function (el) {
      el.textContent = hasDiscount ? v.compareFmt : '';
      el.hidden = !hasDiscount;
    });
    $$('[data-pdt-badge]').forEach(function (el) {
      if (hasDiscount) {
        el.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
        el.hidden = false;
      } else { el.hidden = true; }
    });
    var canBuy = !!(v && v.available);
    $$('[data-pdt-atc],[data-pdt-buynow],[data-pdt-sticky-atc]').forEach(function (b) { b.disabled = !canBuy; });
    $$('[data-pdt-atc-label]').forEach(function (el) { el.textContent = canBuy ? cfg.strings.atc : cfg.strings.soldOut; });
    $$('[data-pdt-cod-own],[data-pdt-sticky-cod]').forEach(function (a) { a.classList.toggle('is-disabled', !canBuy); a.setAttribute('aria-disabled', canBuy ? 'false' : 'true'); });
    $$('[data-pdt-option]').forEach(function (fs) {
      var c = $('input:checked', fs), out = $('[data-pdt-option-value]', fs);
      if (out && c) out.textContent = c.value;
      $$('.pdt-chip', fs).forEach(function (l) { l.classList.toggle('is-selected', l.querySelector('input').checked); });
    });
    renderStock();
    if (v && v.media) goToMedia(v.media);
    if (updateUrl && v && window.history && window.history.replaceState) {
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
    }
  }

  $$('[data-pdt-option] input').forEach(function (inp) {
    inp.addEventListener('change', function () {
      setVariant(matchVariant(selectedOptions()), true);
    });
  });

  /* ---------- stoc real ---------- */
  function renderStock() {
    var v = state.variant, s = cfg.stock;
    $$('[data-pdt-stock]').forEach(function (el) {
      var text = $('.pdt-stock__text', el), bar = $('.pdt-stock__bar', el), fill = $('.pdt-stock__bar span', el);
      el.classList.remove('is-low', 'is-ok', 'is-out');
      if (!s.enabled || !v) { el.hidden = true; return; }
      if (!v.available) {
        text.textContent = s.textOut; bar.hidden = true; el.classList.add('is-out'); el.hidden = false; return;
      }
      if (v.tracked && v.qty > 0 && v.qty <= s.threshold) {
        text.textContent = '';
        var parts = s.textLow.split('{qty}');
        text.appendChild(document.createTextNode(parts[0]));
        var b = document.createElement('b'); b.textContent = v.qty; text.appendChild(b);
        text.appendChild(document.createTextNode(parts.slice(1).join('{qty}')));
        fill.style.width = Math.max(8, Math.round(v.qty / s.threshold * 100)) + '%';
        bar.hidden = false; el.classList.add('is-low'); el.hidden = false; return;
      }
      if (s.showOk) { text.textContent = s.textOk; bar.hidden = true; el.classList.add('is-ok'); el.hidden = false; return; }
      el.hidden = true;
    });
  }

  /* ---------- cronometre ---------- */
  var offerEnd = cfg.offer && cfg.offer.end ? Date.parse(cfg.offer.end) : NaN;

  function paint(el, ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var map = { d: Math.floor(t / 86400), h: pad(Math.floor(t % 86400 / 3600)), m: pad(Math.floor(t % 3600 / 60)), s: pad(t % 60) };
    $$('[data-u]', el).forEach(function (u) { u.textContent = map[u.getAttribute('data-u')]; });
    var d = $('[data-u="d"]', el);
    if (d && d.parentNode) d.parentNode.hidden = (map.d === 0);
  }

  function tzNow(tz) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour12: false, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var wdMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { y: +p.year, mo: +p.month, d: +p.day, h: (+p.hour) % 24, mi: +p.minute, s: +p.second, wd: wdMap[p.weekday] };
  }
  function isBusiness(dt) { var w = dt.getUTCDay(); return w >= 1 && w <= 5; }
  function addBusiness(dt, n) {
    var d = new Date(dt.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (isBusiness(d)) n--; }
    return d;
  }
  function fmtDate(dt) {
    try { return dt.toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); }
    catch (e) { return dt.toISOString().slice(0, 10); }
  }
  function hideDispatch() { $$('[data-pdt-dispatch]').forEach(function (e) { e.hidden = true; }); }
  function renderDispatch() {
    var c = cfg.dispatch;
    if (!c || !c.enabled) { hideDispatch(); return; }
    var n;
    try { n = tzNow(c.tz || 'Europe/Bucharest'); } catch (e) { hideDispatch(); return; }
    var cutoff = c.cutoffH * 3600 + c.cutoffM * 60, now = n.h * 3600 + n.mi * 60 + n.s;
    var eligible = n.wd >= 1 && n.wd <= 5 && now < cutoff;
    var base = new Date(Date.UTC(n.y, n.mo - 1, n.d));
    if (!eligible) { do { base.setUTCDate(base.getUTCDate() + 1); } while (!isBusiness(base)); }
    var from = fmtDate(addBusiness(base, c.min)), to = fmtDate(addBusiness(base, Math.max(c.min, c.max)));
    $$('[data-pdt-dispatch]').forEach(function (el) {
      var l1 = $('[data-pdt-dispatch-line]', el), l2 = $('[data-pdt-delivery-line]', el);
      if (l1) {
        l1.textContent = '';
        if (eligible) {
          var parts = c.textToday.split('{timer}');
          l1.appendChild(document.createTextNode(parts[0]));
          var b = document.createElement('b'); b.className = 'pdt-dispatch__timer';
          var left = cutoff - now;
          b.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
          l1.appendChild(b); l1.appendChild(document.createTextNode(parts.slice(1).join('{timer}')));
        } else { l1.textContent = c.textLater; }
      }
      if (l2) {
        var t = c.deliveryText;
        if (from === to) t = t.replace(/\{from\}\s*[–-]\s*\{to\}/, from);
        l2.textContent = t.replace('{from}', from).replace('{to}', to);
      }
      el.hidden = false;
    });
  }

  function tick() {
    var now = Date.now();
    var active = !!(cfg.offer && cfg.offer.enabled && !isNaN(offerEnd) && offerEnd > now);
    $$('[data-pdt-offer]').forEach(function (w) {
      w.hidden = !active;
      if (active) {
        $$('[data-pdt-timer]', w).forEach(function (t) { paint(t, offerEnd - now); });
        w.classList.toggle('is-urgent', offerEnd - now < 86400000);
      }
    });
    renderDispatch();
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- galerie ---------- */
  var track = $('[data-pdt-track]');
  var slides = track ? $$('.pdt-slide', track) : [];
  var thumbs = $$('[data-pdt-thumb]');
  function activeIndex() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function markActive() {
    var i = activeIndex();
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    $$('[data-pdt-dot]').forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    var c = $('[data-pdt-counter]'); if (c) c.textContent = (i + 1) + ' / ' + slides.length;
  }
  function goTo(i) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function goToMedia(id) {
    for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(id)) { goTo(i); return; }
  }
  if (track) {
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(markActive); }, { passive: true });
    window.addEventListener('resize', function () { goTo(activeIndex()); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    $$('[data-pdt-dot]').forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    var prev = $('[data-pdt-prev]'), next = $('[data-pdt-next]');
    if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
    markActive();
  }

  /* ---------- cantitate ---------- */
  $$('[data-pdt-qty]').forEach(function (w) {
    var inp = $('input', w);
    $$('[data-pdt-qty-btn]', w).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-pdt-qty-btn'), 10);
        inp.value = Math.max(1, Math.min(10, v));
      });
    });
  });

  /* ---------- bara lipită (sticky) ---------- */
  var buy = $('[data-pdt-buy-buttons]'), sticky = $('[data-pdt-sticky]');
  if (buy && sticky) {
    var stickyRaf;
    var checkSticky = function () {
      var r = buy.getBoundingClientRect();
      var show = r.bottom < 0;                        // butoanele de cumpărare au ieșit pe sus din ecran
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', function () { cancelAnimationFrame(stickyRaf); stickyRaf = requestAnimationFrame(checkSticky); }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }
  var stickyBtn = $('[data-pdt-sticky-cta]');
  if (stickyBtn) stickyBtn.addEventListener('click', function () {
    /* 1) butonul real Releasit, oriunde e pe pagină */
    var real = document.querySelector('[id*="rsi_buy_now_button"]');
    if (real) { real.click(); return; }
    /* 2) linkul meu manual către Releasit, dacă e pornit din setări */
    var own = $('[data-pdt-cod-own]');
    if (own) { own.click(); return; }
    /* 3) fallback: adaugă în coș, apoi derulează la butoanele de cumpărare */
    var b = form ? $('[data-pdt-atc]', form) : null;
    if (b && !b.disabled) { b.click(); }
    var t = document.getElementById('pdt-buy');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- ancore "Comandă acum" ---------- */
  $$('a[href="#pdt-buy"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('pdt-buy');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---------- Releasit COD: butoanele „Comandă acum” ----------
     Link-ul oficial Releasit care deschide formularul COD este /rsi-btn-hook.
     Dacă Releasit este activ pe pagină, îl lăsăm să preia click-ul (formularul se deschide direct, fără derulare).
     Doar dacă nu găsim nicio urmă de Releasit (ex. previzualizare fără aplicație), evităm pagina 404 și ducem
     clientul la butoanele de cumpărare. */
  function releasitPresent() {
    try {
      if (document.querySelector('[id*="rsi"],[class*="_rsi"],[class*="rsi-"],[data-rsi]')) return true;
      var sc = document.scripts;
      for (var i = 0; i < sc.length; i++) if (/releas|rsi/i.test(sc[i].src || '')) return true;
      for (var k in window) if (/^_?rsi|releasit/i.test(k)) return true;
    } catch (e) {}
    return false;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="rsi-btn-hook"]') : null;
    if (!a || a.classList.contains('is-disabled')) return;
    if (releasitPresent()) return;           // Releasit gestionează formularul
    e.preventDefault();
    var nb = $('[data-pdt-buynow]');
    if (nb && !nb.disabled) { nb.click(); return; }
    var t = document.getElementById('pdt-buy');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  /* ---------- pornire ---------- */
  setVariant(findVariant(cfg.currentVariantId) || cfg.variants[0] || null, false);
})();